import api from '../../../api/user';
import { getField } from 'vuex-map-fields';

const state = () => ({
    instance: {
        uuid: null,
        email: null,
        password: null,
        password_confirmation: null,
        role: 'admin',
        first_name: null,
        last_name: null,
        phone_num: null,
        company: {
            name: null
        },
        subscribe: true,
    },
    errors: [],
    loading: false,
})

// Ensure company object is always initialized
const ensureCompanyExists = (state) => {
    if (!state.instance.company) {
        state.instance.company = { name: null };
    }
}

const getters = {
    getField
}


const actions = {
    register({commit, state}) {
        commit('applyLoading', true);
        commit('applySetErrors', {errors: []});
        let instance = state.instance;
        api.user.register(instance)
            .then(response => {
                commit('applyUserRegistered', response.data)
            })
            .catch(error => {
                if (error.response) {
                    // console.log(error.response.data);
                    // console.log(error.response.status);
                    commit('applySetErrors', error.response.data)
                }
            })
            .finally(() => {
                commit('applyLoading', false);
            })
    }
}


const mutations = {
    updateField(state, { path, value }) {
        // Ensure instance exists
        if (!state.instance) {
            state.instance = {
                uuid: null,
                email: null,
                password: null,
                password_confirmation: null,
                role: 'admin',
                first_name: null,
                last_name: null,
                phone_num: null,
                company: { name: null },
                subscribe: true,
            };
        }
        
        // Handle nested properties manually to avoid vuex-map-fields issues
        if (path === 'company.name' || path.startsWith('company.')) {
            ensureCompanyExists(state);
            if (path === 'company.name') {
                state.instance.company.name = value;
            } else {
                // Handle other company.* paths
                const parts = path.split('.');
                let obj = state.instance.company;
                for (let i = 1; i < parts.length - 1; i++) {
                    if (!obj[parts[i]]) {
                        obj[parts[i]] = {};
                    }
                    obj = obj[parts[i]];
                }
                obj[parts[parts.length - 1]] = value;
            }
        } else if (path.includes('.')) {
            // Handle other nested paths manually
            const parts = path.split('.');
            let obj = state.instance;
            for (let i = 0; i < parts.length - 1; i++) {
                if (!obj[parts[i]]) {
                    obj[parts[i]] = {};
                }
                obj = obj[parts[i]];
            }
            obj[parts[parts.length - 1]] = value;
        } else {
            // For simple properties, set directly on instance
            if (!state.instance) {
                console.error('state.instance is not defined');
                return;
            }
            // Direct assignment should work in Vue 3
            // Create a new object to ensure Vue 3 reactivity picks up the change
            state.instance = { ...state.instance, [path]: value };
        }
    },
    applyLoading(state, flag) {
        state.loading = flag
    },
    applySetErrors(state, data) {
        state.errors = data.errors;
    },
    applyUserRegistered(state, data) {
        let tokens = JSON.stringify({a: data.access_token, r: data.refresh_token})
        window.location = `${process.env.VUE_APP_CABINET_URL}login?_token=${btoa(tokens)}`;
    },
    initializeForm(state) {
        ensureCompanyExists(state);
    }
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}